export const clientCanToBeSend = ({ client, multipleBy, minimum }) => (
  client.quantity >= minimum && Math.floor(client.quantity % multipleBy) === 0 && client.isSelected
);

export const getClientStatusLabel = (client) => {
  const clubLabel = 'é um clube de investimento';
  const ageLabel = 'não é maior de idade';
  const pushLabel = 'não habilitou as notificações no XP APP';
  const suitabilityLabel = 'não possui suitability adequado';
  const termLabel = 'não assinou o termo';
  const labels = [];

  const { pushHabilitado, termoAceito, podeOperar, ehMaiorDeIdade, ehClubeInvestimento } = client;

  if (!pushHabilitado) {
    labels.push(pushLabel);
  }
  if (!ehMaiorDeIdade) {
    labels.push(ageLabel);
  }
  if (ehClubeInvestimento) {
    labels.push(clubLabel);
  }
  if (!podeOperar) {
    labels.push(suitabilityLabel);
  }
  if (!termoAceito) {
    labels.push(termLabel);
  }

  const joinLabels = labels.length > 1 ? labels.slice(0, -1).join(', ')+' e '+labels.slice(-1) : labels;

  return `Cliente ${joinLabels}`;
};

